import { FC, useEffect, useState } from "react";
import DefaultFormParserLayout from "../../../components/Layouts/default-form-parser-layout";
import RangePicker, {
  RangePickerValues,
} from "../../../components/UI/RangePicker";
import Input from "../../../components/UI/Input";
import { Space } from "antd";
import { Output } from "../../../services/types";
import { useLoading } from "../../../context/LoadingProvider/useLoading";
import { isString } from "../../../utils/stringUtils";
import Button from "../../../components/UI/Button";
import { getBingoGameLog } from "../../../services/reports";
import { DateFormatEnum } from "../../../enums/dateFormatEnum";
import { notificationError } from '../../../services/notification'
import dayjs from "dayjs";
import {getCentralCurrentTime} from "../../../utils/dateUtils";

const BingoGameLog: FC = () => {

  const centralCurrentTime = getCentralCurrentTime()
  const initDateStart = centralCurrentTime.format('YYYY-MM-DDTHH:mm:ss')
  const HOUR_AGO = dayjs(initDateStart).subtract(1, "hour");
  const TODAY = dayjs(initDateStart);

  const loading = useLoading();
  const [search, setSearch] = useState<string>("");
  const [report, setReport] = useState<string>("");
  const [rangeDate, setRangeDate] = useState<RangePickerValues>([
    HOUR_AGO,
    TODAY
  ]);

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      refreshReport()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const refreshReport = async (output: Output = Output.HTML) => {

    const startTime = rangeDate[0];
    const endTime = rangeDate[1];

    if (startTime.add(1, "hour").isBefore(endTime)){
      return notificationError("Please select a range less than an hour")
    }

    loading.addLoading();

    const res = await getBingoGameLog({
      output,
      beginDateTime: startTime.format("YYYY-MM-DD HH:mm:ss"),
      endDateTime: endTime.format("YYYY-MM-DD HH:mm:ss"),
      searchExpression: search,
    });

    if (Output.isHTML(output) && isString(res)) {
      setReport(res);
    }

    loading.removeLoading();
  };

  return (
    <DefaultFormParserLayout html={report}>
      <Space direction="horizontal" size="middle" wrap>
        <RangePicker
          value={rangeDate}
          defaultValue={[HOUR_AGO, TODAY]}
          onChange={(e: RangePickerValues) => setRangeDate(e)}
          format={DateFormatEnum.MONTH_DAY_YAEAR_TIME}
          showTime

          allowClear={false}
        />
        <Input
          label="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button onClick={() => refreshReport()} type="primary">
          Refresh
        </Button>

        <Button type="primary" onClick={() => refreshReport(Output.PDF)}>
          Save as PDF
        </Button>
      </Space>
    </DefaultFormParserLayout>
  );
};

export default BingoGameLog;
